import { formatMoney } from '@betterment/core';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';

type ContributionValue = PayrollContributionConfigFragment['value'] | PayrollContributionConfigFragment['bonusValue'];

export function formatContributionValue(value: ContributionValue, destinationName: string): string {
  if (!value) {
    return '';
  }

  switch (value.__typename) {
    case 'PayrollContributionConfigValueAmount':
      return `${formatMoney(value.amount)} to ${destinationName}`;
    case 'PayrollContributionConfigValuePercent':
      return `${value.percent}% to ${destinationName}`;
    default:
      return '';
  }
}

export function bonusEqualsBase(config: PayrollContributionConfigFragment): boolean {
  if (!config.bonusValue) {
    return false;
  }

  if (config.value.__typename === 'PayrollContributionConfigValueAmount') {
    return (
      config.bonusValue.__typename === 'PayrollContributionConfigValueAmount' &&
      config.value.amount.cents === config.bonusValue.amount.cents
    );
  }

  if (config.value.__typename === 'PayrollContributionConfigValuePercent') {
    return (
      config.bonusValue.__typename === 'PayrollContributionConfigValuePercent' &&
      config.value.percent === config.bonusValue.percent
    );
  }

  return false;
}
